<div class="transaction-confirmation" [class.transaction-confirmation--visible]="visibility">
    <div class="page-head">
        <app-back (onBack)="onBack()"></app-back>
        <h1 class="title title--size-l text--center">
            {{ headerTitle | translate }}
        </h1>
    </div>
    <div class="page-content page-row">
        <ng-container *ngIf="showLoader">
            <app-loading-spinner style="display: grid; place-content: center; height: 100%"></app-loading-spinner>
        </ng-container>
        <ng-container *ngIf="!showLoader">
            <!-- approve container -->
            <ng-container *ngIf="tx?.signature === 'approve'">
                <div class="data-row tx-amount">
                    <div class="currency__icon-wrapper">
                        <img class="currency__icon" src="/assets/images/icons/info-filled.svg" />
                    </div>
                    <p class="text text--color-secondary text--size-s">
                        {{ "APPROVE-CONFIRMATION.NOTE" | translate }}
                    </p>
                </div>

                <!-- <div class="data-row tx-amount" *ngIf="tx?.value != 0 && !processing">
                    <div class="data-row" style="word-wrap: break-word; max-width: 440px;">
                        <p class="text text--color-secondary text--size-s">
                            {{ "APPROVE-CONFIRMATION.TITLE" | translate }}
                        </p>
                        <p class="text text--bold text--uppercase tx-amount__value">
                            <span *ngIf="tx?.value > 0">-</span>{{ tx?.value | bigNumber: '.2-6' }}
                            {{ tx?.symbol }}
                        </p>
                        <p class="text text--color-secondary text--size-s">
                            ~{{ tx?.price | bigNumber: '.2-6' }} USD
                        </p>
                    </div>
                </div> -->

                <div class="data-row">
                    <p class="text text--color-secondary text--size-s">
                        {{ "COMMON.APPROVE-TOKEN" | translate }}
                    </p>
                    <p class="text text--bold address" [title]="tx?.to">
                        {{ tx?.to | lowercase }}
                    </p>
                </div>

                <div class="data-row">
                    <p class="text text--color-secondary text--size-s">
                        {{ "COMMON.WALLET-ADDRESS" | translate }}
                    </p>
                    <p class="text text--bold address" [title]="tx?.from">
                        {{ tx?.from | lowercase }}
                    </p>
                </div>
            </ng-container>

            <!-- transaction-confirmation conteiner -->
            <ng-container *ngIf="tx?.signature !== 'approve'">
                <div class="data-row tx-amount" *ngIf="tx?.value != 0">
                    <div class="currency__icon-wrapper">
                        <img *ngIf="tx?.icon" class="currency__icon" src="{{ tx?.icon }}" />
                        <p *ngIf="!tx?.icon && !!tx?.symbol" class="title currency__no-icon">
                            {{ tx?.symbol.slice(0, 3) }}
                        </p>
                    </div>
                    <div class="data-row">
                        <p class="text text--bold text--uppercase tx-amount__value">
                            <span *ngIf="tx?.value > 0">-</span>{{ tx?.value | bigNumber : ".2-6" }}
                            {{ tx?.symbol }}
                        </p>
                        <p class="text text--color-secondary text--size-s font-roboto-mono">
                            ~{{ tx?.price | bigNumber : ".2-6" }} USD
                        </p>
                    </div>
                </div>

                <div class="data-row">
                    <p class="text text--color-secondary text--size-s">
                        {{ "COMMON.SENDER-ADDRESS" | translate }}
                    </p>
                    <p class="text text--bold address" [title]="tx?.from">
                        {{ tx?.from | lowercase }}
                    </p>
                </div>

                <div class="data-row">
                    <p class="text text--color-secondary text--size-s">
                        {{ "COMMON.RECIPIENT-ADDRESS" | translate }}
                    </p>
                    <p class="text text--bold address" [title]="tx?.to">
                        {{ tx?.to | lowercase }}
                    </p>
                </div>
            </ng-container>

            <!-- end block -->
            <div class="data-row">
                <p class="text text--color-secondary text--size-s">
                    {{ "COMMON.NETWORK-FEE" | translate }}
                </p>
                <p class="text text--bold">{{ feeAmount }} {{ feeUnit }}</p>
                <p class="text text--color-secondary text--size-s font-roboto-mono">
                    ~{{ tx?.fee?.fee }} {{ tx?.feeSymbol }} ~{{
                    tx?.fee?.fiatFee
                    }}
                    USD
                </p>
            </div>
            <div class="data-row">
                <app-transaction-fee *ngIf="visibility && feeOracle" [fee-oracle]="feeOracle" [symbol]="feeUnit"
                    default-fee="fast" [baseUnit]="tx?.feeSymbol" [show-custom-fee]="true"
                    (onChange)="onFeeChange($event)" (onShowCustomFee)="viewCustomFee()"></app-transaction-fee>
            </div>
            <div class="actions">
                <button *ngIf="allowReject" [disabled]="processing" class="btn" (click)="onBack()">
                    {{ "COMMON.REJECT" | translate }}
                </button>
                <button [disabled]="processing" class="btn" (click)="sendTransaction()">
                    {{ "COMMON.CONFIRM" | translate }}
                </button>
            </div>

            <p *ngIf="processing" style="margin-top: 24px" class="text"
                [innerHTML]="'COMMON.TRANSACTION-PROCESSING' | translate"></p>
            <a *ngIf="etherscanLink" style="margin-top: 24px" target="_blank" href="{{ etherscanLink }}" class="link text"
                [innerHTML]="'COMMON.TRANSACTION-ON-ETHERSCAN' | translate"></a>
        </ng-container>
    </div>
</div>

<app-custom-gas-price *ngIf="showCustomGasPrice" (onChange)="changeFeeCoin($event)" [default-fee]="selectedFee.type"
    (onClose)="viewCustomFee()" [default]="feeAmount" [fee-oracle]="feeOracle" [symbol]="feeUnit"
    [baseBalance]="baseBalance" [baseUnit]="tx?.feeSymbol" [fiatPrice]="feePrice" [fiatBalance]="baseBalanceUSD"
    [fiatCustomFee]="customFeePrice" [fiatCurrency]="fiatCurrency" [fee-limit]="feeLimit"
    [wallet]="currency.getWallet()"></app-custom-gas-price>
